<template>
    <div id="hero" class="form-container home-step" :ref="stepName" style="position:relative">
        <p>Aanbieding alleen geldig voor nieuwe leden</p>
        <h2>Ontdek Test&nbsp;Aankoop <br> 2 maanden lang voor&nbsp;€&nbsp;2!</h2>
        <p>En kies uw welkomstgeschenk uit tientallen merken</p>
        <b-button class="button is-primary next-button" @click="nextStep()">Ontvang mijn pakket voor €2</b-button>
        <p>Beschikbare merken op de catalogus kunnen gewijzigd worden</p>

        <b-loading :is-full-page="false" v-model="loading"></b-loading>
    </div>
</template>

<script>
import {gsap} from 'gsap';
import mixin from "../../../travel_step_mixin";
import ScrollLink from "../../../../../../views/_commons/fr/ScrollLink";
import animation_mixin from "../../../animation_engine_mixin";

export default {
    mixins: [mixin],
    components:{ScrollLink},
    mounted(){

    }
}
</script>
